var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSkewedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "80%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff0089"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffe121"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.95 53.63C24.6 54.18 25.59 54.6 26.83 54.49C27.88 54.39 28.38 53.89 28.37 53.42C28.35 52.8 27.57 52.66 26.52 52.52C25.05 52.35 23.16 52.14 23.11 50.29C23.08 48.91 24.34 47.68 26.45 47.49C27.6916 47.321 28.9514 47.6244 29.98 48.34L28.95 49.72C28.1926 49.1903 27.2691 48.9523 26.35 49.05C25.49 49.12 25.05 49.51 25.05 50.01C25.07 50.57 25.83 50.67 26.87 50.81C28.36 50.98 30.25 51.23 30.3 53.06C30.34 54.58 29.2 55.82 26.78 56.04C26.1053 56.1403 25.4175 56.1053 24.7565 55.937C24.0955 55.7688 23.4746 55.4706 22.93 55.06L23.95 53.63V53.63Z",
    fill: "#626c78"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.18 51.9L33.5 52.74L33.57 55.28L31.66 55.46L31.45 47.18L33.35 47L33.45 50.7L36.53 46.72L38.89 46.52L35.42 50.72L39.34 54.77L36.99 54.98L34.18 51.9Z",
    fill: "#626c78"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 46.41L46.35 45.85L46.39 47.37L41.96 47.76L42 49.56L46.34 49.17L46.38 50.68L42.04 51.08L42.09 53L46.53 52.6L46.57 54.13L40.22 54.7L40 46.41Z",
    fill: "#626c78"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2 47.84L51.79 53.67L49.76 53.84L46.98 45.79L49.12 45.6L50.84 51.45L52.4 45.31L53.89 45.18L55.74 51L57.14 44.88L59.3 44.68L56.95 53.2L54.92 53.38L53.2 47.84Z",
    fill: "#626c78"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2 44.62L66.55 44.05L66.59 45.57L62.16 45.97L62.2 47.77L66.54 47.37L66.58 48.89L62.24 49.27L62.29 51.2L66.73 50.8L66.76 52.33L60.42 52.9L60.2 44.62Z",
    fill: "#626c78"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.76 50.33C73.54 50.17 74.54 48.9 74.51 47.5C74.47 46.04 73.47 45 71.63 45.16L70 45.3L70.13 50.48L71.76 50.33V50.33ZM68.06 43.92L71.59 43.61C74.4 43.36 76.39 44.83 76.46 47.33C76.52 49.83 74.61 51.63 71.8 51.89L68.26 52.2L68.06 43.92V43.92Z",
    fill: "#626c78"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.66 34.19L17.11 40.01L16.95 65.46L83.66 59.1V34.19Z",
    fill: "none",
    stroke: "url(#a)",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkewedIcon);
export default __webpack_public_path__ + "static/media/Skewed-icon.73938643bf9f080f813772fdd8452750.svg";
export { ForwardRef as ReactComponent };